import { connect } from 'react-redux';
import DashboardWalletSocietyDocument from './DashboardWalletSocietyDocument';
const mapStateToProps = (state) => ({
    iss: state.roles.iss,
});
export default connect(mapStateToProps)(DashboardWalletSocietyDocument);
